import PropTypes from 'prop-types';

import AdvisoryPriceDisplayView from '@stubhub/react-advisory-price-display-core';
import {connect} from '@stubhub/react-store-provider';

import controller from './controller';

const AdvisoryPriceDisplay = connect(controller)(AdvisoryPriceDisplayView);

AdvisoryPriceDisplay.propTypes = {
  /** Currency code */
  currency: PropTypes.string,

  /** Price value */
  price: PropTypes.number.isRequired,

  /** Number of decimals to display */
  decimalPlaces: PropTypes.number,

  /** Show loading skeleton */
  isLoading: PropTypes.bool,
};

export default AdvisoryPriceDisplay;
